import { render, staticRenderFns } from "./RAGManagement.vue?vue&type=template&id=4a629700&scoped=true"
import script from "./RAGManagement.vue?vue&type=script&lang=js"
export * from "./RAGManagement.vue?vue&type=script&lang=js"
import style0 from "./RAGManagement.vue?vue&type=style&index=0&id=4a629700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a629700",
  null
  
)

export default component.exports